document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".lhs-nav__level-3-toggle");
    const mobileToggle = document.querySelector(".lhs-nav__level-2-toggle");
    const level3Element = document.querySelector(".lhs-nav__level-3");

    // level 3 toggles
    toggles.forEach((toggle) => {
        const parentLi = toggle.closest(".lhs-nav__level-3-link");
        const targetUl = parentLi.querySelector(".lhs-nav__level-4");

        // Check if the parent element has the 'current' class
        if (parentLi.classList.contains("current")) {
            parentLi.classList.add("accordion-open");
            if (targetUl) {
                targetUl.classList.add("active");
                toggle.setAttribute("aria-expanded", "true");
            }
        }

        // toggle
        toggle.addEventListener("click", function () {
            parentLi.classList.toggle("accordion-open");

            if (targetUl) {
                targetUl.classList.toggle("active");
                const expanded = toggle.getAttribute("aria-expanded") === "true";
                toggle.setAttribute("aria-expanded", !expanded);
            }
        });
    });

    // mobile toggle for the whole component
    if (mobileToggle) {
        mobileToggle.addEventListener("click", () => {
            level3Element.classList.toggle("component-open");
            const expanded = mobileToggle.getAttribute("aria-expanded") === "true";
            mobileToggle.setAttribute("aria-expanded", !expanded);
        })
    }
});
